export default __webpack_public_path__ + "static/service_ap2-079f6b4dd8c2704a10b3f79a8b10046b.png";